import * as Yup from "yup";
import { useState, useEffect, useLayoutEffect } from "react";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import { API_URL } from "../../../../constants";
import { useFormikContext } from "formik";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import { FormikDialog } from "../../../../components/dialogs";
import FormikDateField from "../../../../components/inputs/FormikDateField";
import FormikTextField from "../../../../components/inputs/FormikTextField";
import axios from "axios";

export const initialValues = {
  license: "",
  licenseExpiryDate: "",
};

export const validationSchema = Yup.object().shape({
  license: Yup.string()
    .required(<FormattedMessage id="validation.message.required" />)
    .nullable(),
  licenseExpiryDate: Yup.date()
    .required(<FormattedMessage id="validation.message.required" />)
    .typeError(<FormattedMessage id="validation.message.invalidDateFormat" />)
    .nullable(),
});

export function BrExpiryDialog(props) {
  const home = useSelector((state) => state.home);
  const { open, entity, onClose, onSubmit, normalizeReceivedValues } = props;
  const [entityValues, setEntityValues] = useState();
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (entity) {
      axios
        .get("/api/homes/" + home?.home?.id + "/checkBrExpiry")
        .then((response) => {
          let data = response?.data;
          let entityValues = { ...initialValues, ...data };
          setEntityValues(entityValues);
        })
        .catch((error) => {})
        .finally(() => {
          setLoaded(true);
        });
    } else {
      setEntityValues(initialValues);
    }
  }, [entity]);

  return (
    <FormikDialog
      open={open}
      dialogTitle={"更新牌照"}
      validationSchema={validationSchema}
      onSubmit={onSubmit}
      onClose={onClose}
      maxWidth="sm"
    >
      <EditForm entity={entityValues} />
    </FormikDialog>
  );
}

const EditForm = (props) => {
  const { entity = "" } = props;
  const { initialValues, values, touched, errors, setFieldValue, resetForm } =
    useFormikContext();

  useLayoutEffect(() => {
    resetForm({ values: initialValues });
    if (entity) {
      resetForm({ values: { ...initialValues, ...entity } });
    } else {
      resetForm({ values: initialValues });
    }
  }, [entity]);

  useEffect(() => {}, []);

  return (
    <form>
      <Grid container spacing={2}>
        <Grid item sm={12} xs={12}>
          <Card variant="outlined">
            <CardContent>
              <Grid container spacing={2}>
                <Grid item sm={12} xs={12}>
                  <FormikTextField
                    required
                    label="安老院牌照號碼"
                    name="license"
                  />
                </Grid>
                <Grid item sm={12} xs={12}>
                  <FormikDateField
                    required
                    label="牌照有效期至"
                    name="licenseExpiryDate"
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </form>
  );
};
